module.exports = __webpack_public_path__ + "static/media/FiveX_loading_dye.52883a6b.svg";